import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {CommonConstants} from "../shared/constants/common-constants.enum";
import {RoleTypeEnum} from "../shared/constants/role-type.enum";

@Injectable()
export class UserGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const customerNo = localStorage.getItem(CommonConstants.CUSTOMER_NO);
    const roleType = localStorage.getItem(CommonConstants.ROLE_TYPE);
    if (roleType == RoleTypeEnum.USER && customerNo !== route.paramMap.get('customerNo')) {
      this.router.navigateByUrl(`/meter-cooperative/station/${route.paramMap.get('stationNo')}/customer/${customerNo}`).finally();
      return of(false);
    }
    return of(true);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return Observable.of(true);
  }
}
